import React, {useEffect, useState} from "react";
import classNames from "classnames";
import css from "./AnimatePresence.module.scss";

/**
 * @warning this component does _not_ animate
 * `children` when they unmount.
 */
const AnimatePresence = ({children}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true);
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      className={classNames(css.base, {
        [css.show]: show,
        [css.hide]: !show
      })}>
      {children}
    </div>
  );
};

export default AnimatePresence;
